import "./commentreply.scss";
import { useCommentActions } from "./hooks/useCommentActions";
import CommentBody from "./components/CommentBody";
import ActionButtons from "./components/ActionButtons";
import ReplyForm from "./components/ReplyForm";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ReportModal from "../reportmodal/ReportModal";
import { useState } from "react";
import noAvatarImg from "../../assets/noAvatar.png";

const CommentReply = ({ 
    comment, 
    queryClient, 
    currentUser, 
    postId 
}) => {
    const { state, actions } = useCommentActions(comment, queryClient, postId);

    const [isReportModalOpen, setIsReportModalOpen] = useState(false);

    // const getAvatarSrc = (pic) => (!pic ? "/public/noAvatar.png" : pic.startsWith("http") ? pic : "/upload/" + pic);

    const getAvatarSrc = (pic) => (!pic ? noAvatarImg : pic.startsWith("http") ? pic : "/upload/" + pic);

    const logicClass = comment.logicType ? comment.logicType.toLowerCase() : "";

    return (
        <div className={`commentReply node-${logicClass}`}>
            <div className="comment">
                {!comment.isDeleted && (
                    <img
                        src={getAvatarSrc(comment.profilePic)}
                        alt=""
                    />
                )}

                <div className="info">
                    <CommentBody comment={comment} />

                    {!comment.isDeleted && (
                        <div className="menu-container">
                            <MoreHorizIcon 
                                className="more-icon"
                                onClick={() => actions.setMenuOpen(!state.menuOpen)} 
                            />
                            {state.menuOpen && (
                                <div className="menu-dropdown">
                                    {comment.userId === currentUser.id ? (
                                        <button onClick={actions.handleDeleteClick}>
                                            Delete comment
                                        </button>
                                    ) : (
                                        <button onClick={() => {
                                            setIsReportModalOpen(true);
                                            actions.setMenuOpen(false); 
                                        }}>
                                            Report
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {!comment.isDeleted &&
                        <ActionButtons 
                            comment={comment}
                            currentUser={currentUser}
                            onLike={actions.handleLike}
                            onDeleteClick={actions.handleDeleteClick}    
                            isDeleteModalOpen={state.isDeleteModalOpen} 
                            onConfirmDelete={actions.confirmDelete}      
                            onCancelDelete={actions.cancelDelete}
                            onToggleReply={() => actions.setReplyOpen(!state.replyOpen)}
                        />
                    }
                </div>
            </div>

            {state.replyOpen && (
                <ReplyForm 
                    currentUser={currentUser}
                    value={state.replyDesc}
                    onChange={actions.setReplyDesc}
                    logicType={state.replyLogicType}
                    onLogicTypeChange={actions.setReplyLogicType}
                    onSubmit={actions.handleReplySubmit}
                    targetName={comment.name} 
                    isPending={state.isPending}
                    cooldown={state.cooldown}
                />
            )}

            {comment.children && comment.children.length > 0 && (
                <div className="nestedComments graph-branch">
                    {comment.children.map((child) => (
                        <CommentReply
                            key={child.id}
                            comment={child}
                            queryClient={queryClient}
                            currentUser={currentUser}
                            postId={postId}
                        />
                    ))}
                </div>
            )}

            <ReportModal 
                isOpen={isReportModalOpen} 
                onClose={() => setIsReportModalOpen(false)} 
                targetId={comment.id} 
                targetType="COMMENT" 
            />
        </div>
    );
};

export default CommentReply;